import { useEffect, useState } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { classNames } from "../../helpers/classNames";

const Tabs = ({
  defaultActiveKey = 0,
  items = [],
  selectedIndex,
  setSelectedIndex = () => {},
  onChange = () => {},
  content = true,
  tabWrapperClass,
  tabsClass,
  tabButtonClass,
  type = "tabs", // "tabs" or "menu"
  contentClass,
  activeTabClass,
  tabClass,
  tablistsClass,
  className,
  component,
}) => {
  const isControlled = typeof selectedIndex === "number";
  const [internalIndex, setInternalIndex] = useState(defaultActiveKey);
  const currentIndex = isControlled ? selectedIndex : internalIndex;

  const handleTabChange = (index) => {
    if (!isControlled) {
      setInternalIndex(index);
    }
    setSelectedIndex(index);
  };

  return (
    <TabGroup
      selectedIndex={currentIndex}
      onChange={handleTabChange}
      className={classNames("h-full w-full", className)}
    >
      <div
        className={classNames(
          type === "menu" ? "flex gap-2 items-start" : "",
          tabWrapperClass
        )}
      >
        <div className={classNames("", tablistsClass)}>
          <TabList
            className={classNames(
              type === "menu" ? "flex flex-row lg:flex-col min-w-52 " : "flex",
              tabsClass
            )}
          >
            {items?.map((tab, i) => (
              <Tab
                disabled={tab?.disabled}
                key={i}
                className={classNames(
                  "relative text-sm font-medium focus:outline-none",
                  type === "tabs" ? "border-b-2 pb-3 px-6" : "px-4 py-2 w-fit",
                  tabClass,
                  i === currentIndex
                    ? classNames("text-primary", activeTabClass)
                    : "text-gray-500",
                  tab?.disabled ? "opacity-50 cursor-not-allowed" : "",
                  tabButtonClass
                )}
                onClick={() => {
                  onChange(tab);
                }}
              >
                <div className="flex gap-2 items-center lg:justify-start justify-center">
                  {tab?.icon && <i className={classNames("fa-fw", tab.icon)} />}
                  <span className="whitespace-nowrap">{tab.label}</span>
                </div>
              </Tab>
            ))}
          </TabList>
          {component}
        </div>

        {content && (
          <TabPanels
            className={classNames(
              "relative h-[calc(100%-90px)] px-5 w-full",
              type === "menu" ? "flex-grow px-3" : "mt-5",
              contentClass
            )}
          >
            {items?.map((tab, i) => (
              <TabPanel key={i} className="h-full">
                {tab?.content}
              </TabPanel>
            ))}
          </TabPanels>
        )}
      </div>
    </TabGroup>
  );
};

export default Tabs;
